import React from "react";
import Checkbox from "../checkbox";

const Radio = props => <Checkbox type="radio" {...props} />;

export default Radio;



// WEBPACK FOOTER //
// ./casper/sass/components/radio/radio.js